export const classes = {
  profileCheckoutRequestLayout: 'britive-my-requests-widget-layout',
  profileCheckoutRequestSpacing: 'britive-my-requests-widget-spacing',
  profileCheckoutRequestValue: 'britive-my-requests-widget-value',
  profileCheckoutRequestLabel: 'britive-my-requests-widget-label',
  approverStatusContainer: 'approver-statuses-container',
  managerContainer: 'manager-container',
  approversLabelText: 'approvers-label-text',
}

export const papConsumer = 'papservice'
export const resourceprofile = 'resourceprofile'
